var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { DND_TYPE_DATA_PATH, INJECT_UICORE_DESIGNER } from "../../../../../lib/utils/consts";
import { forEach } from "lodash-es";
import { Component, Inject, Vue } from 'vue-property-decorator';
import { getRelatedPropsOfBinding, isSuitableForBinding } from "../../../../../lib/utils/bindings";
import PropPanelBindingEdit from "../../../../../lib/comps/PropPanel/PropPanel/DataSchemaComponents/BindingEdit";
import { ParamContextProvide } from "../../../../../lib/comps/PropPanel/PropPanel/ParamItem/const";
let BindingEdit = class BindingEdit extends Vue {
  constructor() {
    super(...arguments);
    this.onEvent = {};
  }
  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.onEvent.dragenter = (ev, vm) => {};
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.onEvent.dragleave = (ev, vm) => {};
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.onEvent.dragover = (ev, vm) => {
      ev.preventDefault();
    };
    this.onEvent.drop = (ev, vm) => {
      console.log('drop paramItem');
      this.handleDrop(ev, vm);
    };
    forEach(this.onEvent, (value, key) => this.paramItem.$on(key, value));
  }
  beforeDestroy() {
    forEach(this.onEvent, (value, key) => this.paramItem.$off(key, value));
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleDrop(ev, vm) {
    console.log('drop');
    const binding = this.validBindingDropTarget;
    if (!binding) return;
    ev.preventDefault();
    ev.stopPropagation();
    this.designer.setBinding(this.paramContext.compPath, binding.id, ev.dataTransfer.getData(DND_TYPE_DATA_PATH));
  }
  get prop2bindingMetaLUT() {
    var _this$paramContext;
    const ans = {};
    (_this$paramContext = this.paramContext) === null || _this$paramContext === void 0 || (_this$paramContext = _this$paramContext.compMeta) === null || _this$paramContext === void 0 || (_this$paramContext = _this$paramContext.bindings) === null || _this$paramContext === void 0 || _this$paramContext.forEach(meta => {
      getRelatedPropsOfBinding(meta).forEach(propId => {
        ans[propId] = meta;
      });
    });
    return ans;
  }
  get bindingMeta() {
    const meta = this.prop2bindingMetaLUT[this.propField.id];
    return meta;
  }
  get validBindingDropTarget() {
    const bindingDataStub = this.designer.currentOperation === 'binding' && this.designer.currentBindingDataStub;
    if (!bindingDataStub) return undefined;
    const {
      schema
    } = bindingDataStub;
    const meta = this.bindingMeta;
    if (isSuitableForBinding(meta, schema)) {
      return meta;
    }
  }
  render() {
    var _this$paramContext2;
    const h = arguments[0];
    // @ts-ignore
    return h(PropPanelBindingEdit, {
      "attrs": {
        "value": null,
        "comp": (_this$paramContext2 = this.paramContext) === null || _this$paramContext2 === void 0 ? void 0 : _this$paramContext2.comp,
        "compPath": this.paramContext.compPath,
        "bindingMeta": this.bindingMeta
      }
    });
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER,
  default: null
})], BindingEdit.prototype, "designer", void 0);
__decorate([Inject(ParamContextProvide.context)], BindingEdit.prototype, "paramContext", void 0);
__decorate([Inject('propField')], BindingEdit.prototype, "propField", void 0);
__decorate([Inject('paramItem')], BindingEdit.prototype, "paramItem", void 0);
BindingEdit = __decorate([Component({
  name: 'BindingEdit'
})], BindingEdit);
export { BindingEdit };
//# sourceMappingURL=BindingEdit.js.map
